import React from "react";
import { Menu } from "lucide-react";
import UserMenu from '../common/UserMenu';
import Logo from '../common/Logo';
import NotificationBell from "./NotificationBell";

export default function Header({ onMenuToggle }) {
  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50 flex-shrink-0">
      <div className="flex items-center justify-between h-16 px-8">
        <div className="flex items-center">
          <button
            className="lg:hidden p-2 rounded-xl text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            onClick={onMenuToggle}
          >
            <Menu className="w-5 h-5" />
          </button>
          
          {/* Logo para mobile */}
          <div className="lg:hidden ml-3">
            <Logo variant="compact" />
          </div>
        </div>

        <div className="flex items-center">
          <NotificationBell />

          {/* User Menu */}
          <UserMenu />
        </div>
      </div>
    </header>
  );
}